import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/estadistica',
      name: 'estadistica',
      component: () => import('@/views/estadisiticas/General.vue'),
      // meta: {
      //   // pageTitle: 'Estadistica',
      //   breadcrumb: [
      //     {
      //       text: 'Estadistica',
      //       active: true,
      //     },
      //   ],
      // },
    },
    {
      path: '/inscriptions',
      name: 'inscriptions',
      component: () => import('@/views/inscription/Inscriptions.vue'),
      // meta: {
      //   pageTitle: 'Calificaciones',
      //   breadcrumb: [
      //     {
      //       text: 'Calificaciones',
      //       active: true,
      //       icon: 'PlusIcon',
      //     },
      //   ],
      // },
    },
    {
      path: '/users',
      name: 'users',
      component: () => import('@/views/users/Users.vue'),
    },
    {
      path: '/configuration',
      name: 'configuration',
      component: () => import('@/views/configuration/Configuration.vue'),
    },
    {
      path: '/tecnica',
      name: 'tecnica',
      component: () => import('@/views/tecnica/Tecnica.vue'),
    },
    {
      path: '/horarios',
      name: 'horarios',
      component: () => import('@/views/tecnica/Horarios.vue'),
    },
    {
      path: '/',
      name: 'login',
      component: () => import('@/views/Login.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '/sanciones',
      name: 'sanciones',
      component: () => import('@/views/sanciones/Sanciones.vue'),
    },
    {
      path: '/tesoreria',
      name: 'tesoreria',
      component: () => import('@/views/tesoreria/Tesoreria.vue'),
    },
    {
      path: '/logs',
      name: 'logs',
      component: () => import('@/views/logs/Logs.vue'),
    },
    {
      path: '/profile',
      name: 'profile',
      component: () => import('@/views/perfil/AccountSetting.vue'),
    },
    {
      path: '/news',
      name: 'news',
      component: () => import('@/views/noticias/Noticias.vue'),
    },
    {
      path: '/arbitros',
      name: 'arbitros',
      component: () => import('@/views/arbitros/Arbitros.vue'),
    },
    {
      path: '/ayuda',
      name: 'ayuda',
      component: () => import('@/views/ayuda/Tutoriales.vue'),
    },
    {
      path: '/pagos',
      name: 'pagos',
      component: () => import('@/views/pagos/Pagos.vue'),
    },
    // {
    //   path: '/peticiones',
    //   name: 'peticiones',
    //   component: () => import('@/views/tareas/Tareas.vue'),
    // },
    {
      path: '/reuniones',
      name: 'reuniones',
      component: () => import('@/views/reuniones/Reuniones.vue'),
    },
    {
      path: '/peticiones',
      name: 'peticiones',
      component: () => import('@/views/tareas/Tareas.vue'),
    },
    {
      path: '/error-404',
      name: 'error-404',
      component: () => import('@/views/error/Error404.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '/forgot',
      name: 'forgot',
      component: () => import('@/views/OlvidoContrasenia.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '*',
      redirect: 'error-404',
    },
    // {
    //   path: '/samantha',
    //   name: 'samantha',
    //   component: () => import('@/views/samantha/samantha.vue'),
    // },
  ],
})

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})
// router.beforeEach(() => {
//   // Remove initial loading
//   const appLoading = document.getElementById('loading-bg')
//   if (appLoading) {
//     appLoading.style.display = 'none'
//   }
// })

export default router
